module.exports = __webpack_public_path__ + "img/kruisje-modal.5dc220d63b120aeb485e47cded626d58.svg";